// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__-VcNp","fadeIn":"Modal_fadeIn__kZrH1","dialog":"Modal_dialog__t6Ow1","slideUp":"Modal_slideUp__nEnVC"};